import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const Wrapper = styled.div`
	margin: 20px;
`;

export const DropZoneWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding-top: 10px;
`;

export const FilesWrapper = styled.div`
	display: flex;
	gap: 20px;
	align-items: center;
	.file-name > div:first-child {
		display: none;
	}
`;

export const FileCountContainer = styled.div`
	font-weight: 500;
	font-size: 17px;
	width: 25px;
`;

export const StepCount = styled.div`
	font-weight: 500;
	font-size: 16px;
`;

export const FileNameContainer = styled.div`
	max-width: 400px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;

export const ButtonWrapper = styled.div`
	margin-top: 10px;
	display: flex;
	align-items: center;
	gap: 10px;
`;

export const ErrorMessage = styled.div`
	font-size: 15px;
	color: red;
`;

export const RadioContainer = styled.div`
	width: 100%;
	margin-bottom: 10px;
	margin-top: 10px;
	padding: 5px 10px 5px 10px;
	display: flex;
	align-items: center;
	gap: 20px;
	background-color: #ffffff;
`;

export const RadioLabel = styled.div`
	font-size: 14px;
	font-weight: 500;
`;

export const RadioHeader = styled.div`
	font-size: 16px;
	font-weight: 500;
`;

export const Required = styled.span`
	color: red;
	padding-left: 3px;
`;

export const HeaderContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 10px;
`;

export const FilesContainer = styled.div`
	background-color: #ffffff;
`;

export const ErrorContainer = styled.div`
	font-size: 14px;
	color: red;
	padding-left: 45px;
	padding-top: 5px;
`;

export const NoteWrapper = styled.div`
	font-size: 14px;
	padding-top: 10px;
	color: ${colors.green1};
`;

export const DropWrapper = styled.div`
	background-color: #ffffff;
	padding: 0 10px 10px 10px;
`;
